import moment from "moment";
import { roundToNearestHalfHour } from "./roundToNearestHalfHour";

export const checkApartadoSpecial = (secludedClassrooms, salon, element) => {
  const day = element?.day;
  return secludedClassrooms?.salon?.some((classRoon, index) => {
    const isSameClassRoon = salon.name === classRoon;
    const isStatus = secludedClassrooms?.estatus[index];
    if (isSameClassRoon && isStatus) {
      const isSameDate = secludedClassrooms?.dias[index]
        ?.toLowerCase()
        ?.split(",")
        ?.includes(day);

      const initialHour = moment(
        roundToNearestHalfHour(
          secludedClassrooms?.horario[index]?.split(" - ")[0]
        ),
        "HH:mm"
      );
      const finalHour = moment(
        roundToNearestHalfHour(
          secludedClassrooms?.horario[index]?.split(" - ")[1]
        ),
        "HH:mm"
      );
      const checkHour1 = moment(element?.initialHour, "HH:mm");
      const checkHour2 = moment(element?.finalHour, "HH:mm");
      const isOcupate1 = checkHour1.isBetween(
        initialHour,
        finalHour,
        null,
        "[]"
      );
      const isOcupate2 = checkHour2.isBetween(
        initialHour,
        finalHour,
        null,
        "[]"
      );
      if ((isOcupate1 || isOcupate2) && isSameDate) {
        return true;
      }
      return false;
    }
    return false;
  });
};
